var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAttention = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M187.629 160.017L121.849 29.932C114.447 15.2948 93.5497 15.2948 86.1478 29.932L20.3678 160.017C13.6403 173.322 23.3091 189.048 38.2184 189.048H169.778C184.688 189.044 194.357 173.322 187.629 160.017ZM103.998 172.217C97.0637 172.217 91.4412 166.594 91.4412 159.66C91.4412 152.725 97.0637 147.103 103.998 147.103C110.933 147.103 116.556 152.725 116.556 159.66C116.556 166.594 110.933 172.217 103.998 172.217ZM116.604 116.674C116.604 123.638 110.962 129.28 103.998 129.28C97.0353 129.28 91.3925 123.638 91.3925 116.674V70.9795C91.3925 64.0164 97.0353 58.3736 103.998 58.3736C110.962 58.3736 116.604 64.0164 116.604 70.9795V116.674Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAttention, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/attention.f824ffbd.svg";
export { ForwardRef as ReactComponent };